import { useEffect, useState } from 'react';
import { isValidUrl } from '../helper/isValidUrl';

const getYoutubeEmbeddedUrl = (url) => {
	url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
	// eslint-disable-next-line no-useless-escape
	const id = undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
	if (id) {
		return `https://www.youtube.com/embed/${id}`;
	}
	return false;
};
const getVimeoEmbeddedUrl = (url) => {
	const id = /vimeo.*\/(\d+)/i.exec(url);
	if (id) {
		return `https://player.vimeo.com/video/${id[1]}`;
	}
	return false;
};

export default function useVideoUrl(dType, isVideo, vUrl) {
	const [videoUrl, setVideoUrl] = useState(null);

	useEffect(() => {
		if (isVideo && vUrl) {
			const validUrl = isValidUrl(vUrl);
			if (validUrl && validUrl === 'https:') {
				const vimeo = getVimeoEmbeddedUrl(vUrl);
				if (vimeo) {
					setVideoUrl({ type: 'vimeo', url: vUrl });
				} else {
					const youtube = getYoutubeEmbeddedUrl(vUrl);
					setVideoUrl({ type: 'youtube', url: youtube });
				}
			}
		}
	}, [dType, isVideo, vUrl]);

	return { videoUrl };
}
